/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Acidity_PlaceholderInputs */

const en_acidity_placeholder = /** @type {(inputs: Acidity_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Medium-High`)
};

const es_acidity_placeholder = /** @type {(inputs: Acidity_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Media-Alta`)
};

/**
* | output |
* | --- |
* | "e.g. Medium-High" |
*
* @param {Acidity_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const acidity_placeholder = /** @type {((inputs?: Acidity_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Acidity_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_acidity_placeholder(inputs)
	return es_acidity_placeholder(inputs)
});